import React from 'react';
import FormInput from "../../Atoms/Templates/FormInput";
import FloatContainer from "../../Wrappers/FloatContainer";
import FloatEmployeeList from "../FloatEmployeeList";

const SelectEmployeeInput = () => {
  return (
    <div>
      <FloatContainer>
        <FormInput
          label="Empleado"
          isRequired
          placeholder="Busca por nombre o id"/>
        <FloatEmployeeList/>
      </FloatContainer>
    </div>
  );
};

export default SelectEmployeeInput;
